import { render, staticRenderFns } from "./TeacherSupervisorReviewForm.vue?vue&type=template&id=2e11861c&"
import script from "./TeacherSupervisorReviewForm.vue?vue&type=script&lang=js&"
export * from "./TeacherSupervisorReviewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports